import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "swiper-wrapper" }
const _hoisted_2 = { class: "c-hero-landing__bg" }
const _hoisted_3 = {
  key: 0,
  class: "c-hero-landing__overlay"
}
const _hoisted_4 = {
  key: 1,
  class: "c-hero-landing__content"
}
const _hoisted_5 = { class: "c-hero-landing__body" }
const _hoisted_6 = {
  key: 0,
  class: "c-hero-landing__title"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 3,
  class: "c-hero-landing__actions"
}

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { destroySwiper } from '@/utils/site-utils';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { HeroLandingProps } from '@/types/components/HeroLanding';
import utils from '@/utils';
import 'swiper/css';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroLanding',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;

let swiper: Swiper | null = null;
const swiperEl = ref<HTMLElement | null>(null);
const paginationEl = ref<HTMLElement | null>(null);

const slides = computed(() => props.fields?.slides ?? []);
const hasFieldValue = (field?: { value?: unknown }) => {
  if (typeof field?.value === 'string') {
    return field.value.replace(/<[^>]*>/g, '').trim().length > 0;
  }

  return Boolean(field?.value);
};
const hasSlideContent = (slide: (typeof slides.value)[number]) => {
  const fields = slide?.fields;
  return (
    hasFieldValue(fields?.title) ||
    hasFieldValue(fields?.body) ||
    hasFieldValue(fields?.button?.fields?.text)
  );
};
const layout = computed(() => {
  const value = props.fields?.layout?.fields?.phrase?.value;
  return value === 'center' ? 'center' : 'left';
});
const rootClass = computed(() => {
  const result = utils.overall.baseComClass(props.fields, 'c-hero-landing');
  result.push(`c-hero-landing--align-${layout.value}`);
  return result;
});

const rootStyle = computed(() => {
  return utils.overall.baseComStyle(props.fields);
});
const buildSwiper = () => {
  if (!swiperEl.value || !paginationEl.value) return;
  const slidesLen = slides.value.length;
  if (!slidesLen) return;

  destroySwiper(swiper, true, true);
  swiper = new Swiper(swiperEl.value, {
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    modules: [Pagination],
    pagination: {
      el: paginationEl.value,
      clickable: true,
      bulletElement: 'span',
    },
  });
};

onMounted(() => {
  setTimeout(() => nextTick(() => buildSwiper()), 50);
});

watch(
  () => slides.value.length,
  (newLen, oldLen) => {
    if (newLen > 0 && newLen !== oldLen) {
      nextTick(() => buildSwiper());
    }
  }
);

onBeforeUnmount(() => {
  destroySwiper(swiper, true, true);
});

return (_ctx: any,_cache: any) => {
  const _component_AdaptiveMedia = _resolveComponent("AdaptiveMedia")!
  const _component_SiteButton = _resolveComponent("SiteButton")!

  return (__props.fields)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value)
      }, [
        _createElementVNode("div", {
          class: "swiper c-hero-landing__swiper",
          ref_key: "swiperEl",
          ref: swiperEl
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slides.value, (slide, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: slide.id || index,
                class: "swiper-slide c-hero-landing__slide"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (slide.fields?.image)
                    ? (_openBlock(), _createBlock(_component_AdaptiveMedia, {
                        key: 0,
                        field: slide.fields?.image,
                        class: "c-hero-landing__bg-img",
                        "is-background": false,
                        "lazy-load": index !== 0,
                        priority: index === 0,
                        options: {
                autoplay: true,
                loop: true,
                controls: false,
                preload: index === 0 ? 'auto' : 'metadata',
              },
                        "show-image-redius": false
                      }, null, 8, ["field", "lazy-load", "priority", "options"]))
                    : _createCommentVNode("", true)
                ]),
                (hasSlideContent(slide))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                  : _createCommentVNode("", true),
                (hasSlideContent(slide))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (slide.fields?.title && index === 0)
                          ? (_openBlock(), _createElementBlock("h1", _hoisted_6, [
                              _createElementVNode("strong", {
                                innerHTML: slide.fields.title.value
                              }, null, 8, _hoisted_7)
                            ]))
                          : _createCommentVNode("", true),
                        (slide.fields?.title && index !== 0)
                          ? (_openBlock(), _createBlock(_unref(RichText), {
                              key: 1,
                              class: "c-hero-landing__title",
                              field: slide.fields.title
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true),
                        (slide.fields?.body)
                          ? (_openBlock(), _createBlock(_unref(RichText), {
                              key: 2,
                              class: "c-hero-landing__desc",
                              field: slide.fields.body
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true),
                        (slide.fields?.button)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_SiteButton, _mergeProps({ ref_for: true }, slide.fields?.button), null, 16)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "c-hero-landing__pagination swiper-pagination",
            ref_key: "paginationEl",
            ref: paginationEl
          }, null, 512), [
            [_vShow, slides.value.length > 1]
          ])
        ], 512)
      ], 6))
    : _createCommentVNode("", true)
}
}

})